import React, { useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

// Lightweight touch-based pull-to-refresh for mobile. Triggers onRefresh when
// the user pulls down past the threshold while scrolled to the top.
export default function PullToRefresh({ onRefresh, children }) {
  const startY = useRef(null);
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const THRESH = 70;

  const onStart = (e) => {
    startY.current = window.scrollY <= 0 && !refreshing ? e.touches[0].clientY : null;
  };
  const onMove = (e) => {
    if (startY.current == null) return;
    const d = e.touches[0].clientY - startY.current;
    if (d > 0) setPull(Math.min(d * 0.5, 90));
  };
  const onEnd = async () => {
    if (startY.current == null) return;
    startY.current = null;
    if (pull >= THRESH && onRefresh) {
      setRefreshing(true);
      try { await onRefresh(); } finally { setRefreshing(false); }
    }
    setPull(0);
  };

  return (
    <div onTouchStart={onStart} onTouchMove={onMove} onTouchEnd={onEnd} data-testid="pull-to-refresh">
      <div className="flex items-center justify-center overflow-hidden" style={{ height: refreshing ? 44 : pull, transition: startY.current == null ? "height 0.2s ease" : "none" }}>
        {(pull > 0 || refreshing) && (
          <span className="flex items-center gap-2 ek-mono-label" style={{ color: "var(--ek-primary)" }}>
            <RefreshCw className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`} style={{ transform: refreshing ? "none" : `rotate(${pull * 3}deg)` }} />
            {refreshing ? "REFRESHING…" : pull >= THRESH ? "RELEASE TO REFRESH" : "PULL TO REFRESH"}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}
